var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ats-edit-form"
  }, [_c('fieldset', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hasExistingATSData),
      expression: "!hasExistingATSData"
    }],
    staticClass: "field"
  }, [_c('label', {
    staticClass: "cm-label",
    attrs: {
      "for": "company_ats_url"
    }
  }, [_vm._v(_vm._s(_vm.translate("activerecord.attributes.company.ats_url")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ats_url),
      expression: "ats_url"
    }],
    staticClass: "cm-field",
    attrs: {
      "type": "url",
      "id": "company_ats_url"
    },
    domProps: {
      "value": (_vm.ats_url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ats_url = $event.target.value
      }
    }
  }), _vm._v(" "), _c('aside', {
    staticClass: "cm-desc"
  }, [_c('Markdown', {
    attrs: {
      "input": _vm.translate('company_ats_url_helper_text')
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ats_provider || _vm.ats_username),
      expression: "ats_provider || ats_username"
    }]
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ats_url),
      expression: "ats_url"
    }],
    staticClass: "cm-notice"
  }, [_vm._v(_vm._s(_vm.translate("forms.ats.autofilled_ats_properties")))]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "cm-label required",
    attrs: {
      "for": ""
    }
  }, [_vm._v(_vm._s(_vm.translate("activerecord.attributes.company.ats_provider")))]), _vm._v(" "), _vm._l((_vm.providers), function(provider) {
    return _c('label', {
      key: provider.value,
      staticClass: "ats-edit-form__radio"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ats_provider),
        expression: "ats_provider"
      }],
      attrs: {
        "name": "company[ats_provider]",
        "type": "radio",
        "required": ""
      },
      domProps: {
        "value": provider.value,
        "checked": _vm._q(_vm.ats_provider, provider.value)
      },
      on: {
        "__c": function($event) {
          _vm.ats_provider = provider.value
        }
      }
    }), _vm._v("\n          " + _vm._s(provider.label) + "\n        ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "cm-label required",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n          " + _vm._s(_vm.translate("activerecord.attributes.company.ats_username")) + "\n        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ats_username),
      expression: "ats_username"
    }],
    staticClass: "cm-field",
    attrs: {
      "name": "company[ats_username]",
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.ats_username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ats_username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('Markdown', {
    staticClass: "cm-desc",
    attrs: {
      "input": _vm.translate(
        'activerecord.attributes.company.ats_username_helper_text', {
          provider: _vm.activeProvider.label
        }
      )
    }
  })], 1), _vm._v(" "), (_vm.ats_provider === 'greenhouse') ? _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "cm-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n          " + _vm._s(_vm.translate("activerecord.attributes.company.ats_referral_code")) + "\n        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ats_referral_code),
      expression: "ats_referral_code"
    }],
    staticClass: "cm-field",
    attrs: {
      "name": "company[ats_referral_code]",
      "type": "text"
    },
    domProps: {
      "value": (_vm.ats_referral_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ats_referral_code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('Markdown', {
    staticClass: "cm-desc",
    attrs: {
      "input": _vm.translate(
        "activerecord.attributes.company.ats_referral_code_helper_text", {
          provider: _vm.activeProvider.label
        }
      )
    }
  })], 1) : _vm._e()])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4f3335c","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/ats-edit-form.vue
// module id = null
// module chunks = 